import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, styled } from '@mui/material';
import { ReactNode } from 'react';

const Container = styled(Box)(({ theme }) => ({
  height: '100vh',
  color: theme.palette.text.tertiary,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

const ErrorCode = styled('h1')(({ theme }) => ({
  fontSize: theme.typography.h1.fontSize,
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

const ErrorTitle = styled('h2')(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));

const ErrorMessage = styled('p')(({ theme }) => ({
  maxWidth: '768px',
  textAlign: 'center',
  fontSize: theme.typography.h4.fontSize,
  marginTop: theme.spacing(6),
}));

const ErrorAction = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(9),
}));

interface ErrorPageProps {
  code: number;
  title: string;
  message: ReactNode;
  action?: ReactNode;
}

export const ErrorPage = ({
  code = 500,
  title,
  message,
  action,
}: Partial<ErrorPageProps>) => {
  return (
    <Container>
      <WarningAmberIcon fontSize="large" />
      <ErrorCode>{code}</ErrorCode>
      <ErrorTitle>{title}</ErrorTitle>
      <ErrorMessage>{message}</ErrorMessage>

      {action && <ErrorAction>{action}</ErrorAction>}
    </Container>
  );
};
